import React, { useEffect, useState } from "react";
import { SiSpeedtest } from "react-icons/si";
import { FaRegCalendarAlt } from "react-icons/fa";
import ServiceIcon from "./service-icon";
import RemainingWS from "./remaining-ws";
import RemainingTS from "./remaining-ts";
import BeforAfterWS from "./befor-after-ws";
import BeforAfterTS from "./befor-after-ts";
import { Link } from "react-router-dom";
import { CiEdit } from "react-icons/ci";
import { parseLocalizedNumber } from "../../../services/functions";

const CardTwoSide = ({
  // serviceType,
  // serviceTitle,
  // categoryId,
  // remain,
  // beforService,
  // afterService,
  // lastDate,
  // carTitle,
  service,
  min,
  max,
  now
}) => {
  const [progress, setProgress] = useState(0);
  
  useEffect(() => {
    const percentage = ((now - min) / (max - min)) * 100;
    setProgress(Math.min(Math.max(percentage, 0), 100));
  }, [now, min, max]);

  let printRemain =parseLocalizedNumber(service.remain);

  return (
    <div
      className="card mb-3 mx-auto shadow-sm text-dark bg-light"
      style={{
        maxWidth: "360px",
        direction: "rtl",
        fontFamily: "Yekan, sans-serif",
        borderRadius: "0.375rem",
      }}
    >
      {/* Header */}
      <div className="card-header py-1">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="d-flex align-items-center gap-1">
              <ServiceIcon categoryId={service.ok_id} />
              <div>
                <div className="fw-bold" style={{ fontSize: "0.95rem" }}>
                  {service.opTitle}
                </div>
                <p className="text-black-50 mb-0" style={{ fontSize: "0.8rem" }}>
                  {service.car_title}
                </p>
              </div>
            </div>
          </div>
  
          {/* فقط آیکون نوع سرویس در هدر موند */}
          {service.ok_serviceType === "km" ? (
            <SiSpeedtest size={18} />
          ) : (
            <FaRegCalendarAlt size={18} />
          )}
        </div>
      </div>
  
      {/* Body */}
      <div className="card-body py-2" style={{ padding: "0.75rem 1rem" }}>
        <div className="card-title mb-1">
          {service.ok_serviceType === "km" ? (
            <RemainingWS remain={service.remain} />
          ) : (
            <RemainingTS remain={service.remain} />
          )}
        </div>
  
        <div className="card-text mb-1">
          {/* Progress */}
          <div className="progress mb-1" style={{ height: "2px" }}>
            <div
              className={`progress-bar ${
                printRemain < 0 ? "bg-danger" : "bg-success"
              }`}
              role="progressbar"
              style={{
                width: `${progress}%`,
                transition: "width 3s ease-in-out",
              }}
              aria-valuenow={now}
              aria-valuemin={min}
              aria-valuemax={max}
            ></div>
          </div>
  
          {/* Before / After */}
          {service.ok_serviceType === "km" ? (
            <BeforAfterWS
              beforService={service.lastKm}
              afterService={service.programKm}
            />
          ) : (
            <BeforAfterTS
              beforService={service.lastDateP}
              afterService={service.programDateP}
            />
          )}
  
          {/* Last Service */}
          {service.ok_serviceType === "km" ? (
            <div className="mt-1" style={{ fontSize: "12px", textAlign: "left" }}>
              سرویس قبلی: {service.lastDateP}
            </div>
          ) : (
            <div className="mt-1" style={{ fontSize: "12px", textAlign: "left" }}>
              سرویس قبلی: {service.lastKm} کیلومتر
            </div>
          )}

          {/* دکمه ثبت انتقال یافته به پایین */}
          <div className="mt-3">
            <Link
              className="btn btn-success w-100 py-2 d-flex align-items-center justify-content-center gap-2"
              to={"/oper-reg"}
              state={service}
              title="ثبت سرویس انجام شده"
              style={{
                fontSize: "1rem",
                fontWeight: "500"
              }}
            >
              <CiEdit size={20} />
              انجام شد
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
  
};

export default CardTwoSide;
